import Constants from "@/constants";
import {Modal} from "bootstrap";

export function pageCountFromTotal(totalCount, pageSize)
{
    return Math.floor((totalCount + (pageSize - 1)) / pageSize);
}

export function stringToBase64URL(str)
{
    return bytesToBase64URL(new TextEncoder().encode(str));
}

export function bytesToBase64URL(bytes)
{
    const b = Array.from(bytes, (byte) => String.fromCodePoint(byte),).join("");
    return window.btoa(b).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function arrayBufferToBase64URL(buffer)
{
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;

    for (let i = 0; i < len; ++i)
    {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function encodeBase64Url(arrayBuffer)
{
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.length;

    let base64 = '';

    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

    for (let i = 0; i < len; i += 3)
    {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2)
    {
        base64 = base64.substring(0, base64.length - 1);
    }
    else if (len % 3 === 1)
    {
        base64 = base64.substring(0, base64.length - 2);
    }

    return base64;
}

export function decodeBase64URL(str)
{
    const base64Encoded = str.replace(/-/g, '+').replace(/_/g, '/');
    const padding = str.length % 4 === 0 ? '' : '='.repeat(4 - (str.length % 4));
    const base64WithPadding = base64Encoded + padding;
    const binaryString = window.atob(base64WithPadding);
    let r = [];

    for (let i = 0; i < binaryString.length; ++i) {
        r.push(binaryString.charCodeAt(i));
    }

    return new Uint8Array(r);
}

export function arrayBufferToHexEncodedString(buffer)
{
    return [...new Uint8Array(buffer)]
        .map(x => Number(x).toString(16).padStart(2, '0'))
        .join('');
}

export function handleLoginResponse(loginResponseDto, rememberMe, router, serverMessageCallback = null)
{
    localStorage.setItem(Constants.localStorageKeyUserId, loginResponseDto?.userId);
    localStorage.setItem(Constants.localStorageKeyAuthToken, loginResponseDto?.token);
    localStorage.setItem(Constants.localStorageKeyServerVersionNumber, loginResponseDto?.serverVersionNumber);

    localStorage.removeItem(Constants.localStorageKeyLoginState);
    localStorage.removeItem(Constants.localStorageKeyLoginChallenge);
    localStorage.removeItem(Constants.localStorageKeyLoginChallengeS256);

    if (rememberMe)
    {
        localStorage.setItem(Constants.localStorageKeyDefibrillatorToken, loginResponseDto?.defibrillatorToken);
    }
    else
    {
        localStorage.removeItem(Constants.localStorageKeyDefibrillatorToken);
    }

    localStorage.removeItem(Constants.localStorageKeySearchTerm);

    if (serverMessageCallback && loginResponseDto.serverMessage)
    {
        serverMessageCallback(loginResponseDto.serverMessage);
        return;
    }

    dismissServerMessage(router);
}

export function dismissServerMessage(router)
{
    const returnUrl = localStorage.getItem(Constants.localStorageKeyLoginReturnUrl);
    localStorage.removeItem(Constants.localStorageKeyLoginReturnUrl);
    router.push(returnUrl ? returnUrl : "/");
}